import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { setIsAuthenticated } from '../store/auth.reducer'

import { useAppDepsContext } from '~/core/hooks/useAppDepsContext'

export default function useLogout() {
  const { authService } = useAppDepsContext()
  const dispatch = useDispatch()
  const history = useHistory()

  const logout = useCallback(() => {
    authService.logout()
    dispatch(setIsAuthenticated(false))
    window.location.href = 'https://accounts.google.com/logout'
  }, [])

  return logout
}
